module.exports = __webpack_public_path__ + "img/spain.42d5cabf.svg";